
import React, { useState, useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMapMarkerAlt, faPhone, faEnvelope } from '@fortawesome/free-solid-svg-icons';
import './Contact.css';

const Contact = () => {
  const [submitted, setSubmitted] = useState(false);
  const formRef = useRef(null);

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Manually submit the form
    if (formRef.current) {
      // Split full name into first and last names
      const fullNameInput = formRef.current.elements.namedItem('fullName');
      if (fullNameInput && fullNameInput.value.trim().includes(' ')) {
        const [firstName, ...lastNameParts] = fullNameInput.value.trim().split(' ');
        const lastName = lastNameParts.join(' ');
        
        // Create hidden inputs for first and last names
        const firstNameInput = document.createElement('input');
        firstNameInput.type = 'hidden';
        firstNameInput.name = 'first_name';
        firstNameInput.value = firstName;
        formRef.current.appendChild(firstNameInput);
        
        const lastNameInput = document.createElement('input');
        lastNameInput.type = 'hidden';
        lastNameInput.name = 'last_name';
        lastNameInput.value = lastName;
        formRef.current.appendChild(lastNameInput);
      }
      
      formRef.current.submit();
      setSubmitted(true);
    }
  };

  if (submitted) {
    return (
      <div className="contact">
        <div className="contact__container">
          <div className="form-success">
            <h2>Thank You!</h2>
            <p>Your information has been submitted successfully. We'll get back to you soon.</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="contact">
      <div className="contact__container">
        <h1 className="contact__title">Contact Us</h1>
        
        <div className="contact__content">
        <div className="contact__info">
            <div className="contact__info-card">
              <FontAwesomeIcon icon={faMapMarkerAlt} className="contact__icon" />
              <h3 className="contact__info-title">Our Office</h3>
              <p className="contact__info-text">Asif Nagar, Karimnagar, Telangana, India</p>
            </div>
            
            <div className="contact__info-card">
              <FontAwesomeIcon icon={faPhone} className="contact__icon" />
              <h3 className="contact__info-title">Phone</h3>
              <p className="contact__info-text">
                <a href="tel:+916309012237" className="contact__link">
                  +91 6309012237
                </a>
              </p>
              {/* <p className="contact__info-text">
                <a href="tel:+919441222237" className="contact__link">
                  +91 9441222237
                </a>
              </p> */}
              <div className="contact__whatsapp-buttons">
                <a
                  href="https://wa.me/916309012237?text=Hi%20CodeXLNC,%20I%20have%20a%20question%20about%20your%20courses"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="contact__whatsapp-btn"
                >
                  WhatsApp 6309012237
                </a>
                {/* <a
                  href="https://wa.me/919441222237?text=Hi%20CodeXLNC,%20I%20have%20a%20question%20about%20your%20courses"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="contact__whatsapp-btn"
                >
                  WhatsApp 9441222237
                </a> */}
              </div>
            </div>
            
            <div className="contact__info-card">
              <FontAwesomeIcon icon={faEnvelope} className="contact__icon" />
              <h3 className="contact__info-title">Email</h3>
              <p className="contact__info-text">
                <a href="mailto:info@codexlnc.com" className="contact__link">
                  info@codexlnc.com
                </a>
              </p>
              <p className="contact__info-text">
                <a href="mailto:support@codexlnc.com" className="contact__link">
                  support@codexlnc.com
                </a>
              </p>
              <p className="contact__info-text">
                <a href="mailto:codexlnc.cxc@gmail.com" className="contact__link">
                  codexlnc.cxc@gmail.com
                </a>
              </p>
            </div>
          </div>
          
          
          <div className="contact__form-container">
            <h2 className="contact__form-title">Get in Touch</h2>
            <form 
              ref={formRef}
              action="https://webto.salesforce.com/servlet/servlet.WebToLead?encoding=UTF-8"
              method="POST"
              className="contact__form"
              onSubmit={handleSubmit}
            >
              <input type="hidden" name="oid" value="00DgK000002SOUb" />
              <input type="hidden" name="retURL" value="https://www.codexlnc.com" />
              <input type="hidden" name="company" value="Code XLNC" />
              <input type="hidden" name="salutation" value="Mr." />

              <div className="contact__form-group">
                <input
                  type="text"
                  name="fullName"
                  placeholder="Full Name (First and Last)"
                  className="contact__input"
                  required
                />
              </div>
              
              <div className="contact__form-group">
                <input
                  type="tel"
                  name="phone"
                  placeholder="Phone Number"
                  className="contact__input"
                  required
                />
              </div>
              
              <div className="contact__form-group">
                <input
                  type="email"
                  name="email"
                  placeholder="Email Address"
                  className="contact__input"
                  required
                />
              </div>
              
              <div className="contact__form-group">
                <select
                  name="country_code"
                  className="contact__select"
                  required
                >
                  <option value="">Select Country</option>
                  <option value="IN">India</option>
                  <option value="US">United States</option>
                  <option value="GB">United Kingdom</option>
                </select>
              </div>
              
              <button type="submit" className="contact__submit-btn">
                Submit
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;